import { render, staticRenderFns } from "./UiMarketOrders.vue?vue&type=template&id=b5029688&"
import script from "./UiMarketOrders.vue?vue&type=script&lang=js&"
export * from "./UiMarketOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports